import { render, staticRenderFns } from "./stepRealTimeReview.vue?vue&type=template&id=1288288e&scoped=true"
import script from "./stepRealTimeReview.vue?vue&type=script&lang=js"
export * from "./stepRealTimeReview.vue?vue&type=script&lang=js"
import style0 from "./stepRealTimeReview.vue?vue&type=style&index=0&id=1288288e&prod&scoped=true&lang=css"
import style1 from "./stepRealTimeReview.vue?vue&type=style&index=1&id=1288288e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1288288e",
  null
  
)

export default component.exports